export default __webpack_public_path__ + "static/media/ic_calendar1.57bdc840.svg";